<template>
    <div id="wa-business-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('whatsapp_business_api.businessChannelDetail') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>
        <div class="wrapper" v-if="channel">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/whatsapp-business-api')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <WhatsappBusinessIcon />
                    </div>
                    <div class="name">{{ $t("whatsapp_business_api.title") }} :{{ channel.name }}</div>
                </div>
                <div class="right">
                    <a-button type="primary" @click="visible = true" :loading="loading">
                        {{ $t("wp.startChatWithAnyNo") }}
                    </a-button>
                    <a-button type="danger" @click="deleteModal = true"
                        >{{ $t("whatsappChannel.deleteChannel") }}
                    </a-button>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content">
                    <div v-if="currentTab === WABusinessMenuTypes.CHANNEL.id">
                        <UpdateDetail v-model="channel" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.VISIBILITY.id">
                        <Visibility v-model="channel" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.TEMPLATE_MESSAGE_LIST.id">
                        <TemplateMessageList v-model="channel" :changePage="changePage" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.NEW_TEMPLATES.id">
                        <TemplateMessageForm :channel="channel" :changePage="changePage" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.CHAT_STARTER_TEMPLATE.id">
                        <ChatInitiatorTemplate v-model="channel" :changePage="changePage" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.LIVE_NUMBER.id">
                        <Numbers v-model="channel" :changePage="changePage" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.DAILY_USAGES.id">
                        <DailyUsages v-model="channel" :changePage="changePage" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.BROADCAST_REQUESTS.id">
                        <BroadcastRequests :channel="channel" :changePage="changePage" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.CUSTOMER_GROUPS.id">
                        <CustomerGroups :channel="channel" :changePage="changePage" :channel-id="channel._id" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.CONTACTS.id">
                        <AllContacts :channel="channel" :channel-id="channel._id" />
                    </div>
                    <div v-if="currentTab === WABusinessMenuTypes.WALLET.id" style="padding: 10px">
                        <Wallet />
                    </div>
                </div>
            </div>
        </div>
        <a-modal
            :title="$t('wp.typeInANumberDesc')"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="startChat(whatsappNumber)"
            @cancel="handleCancel"
            class="row d-flex flex-row"
        >
            <div v-if="showAlertMessage" class="pb-3">
                <a-alert :message="$t('wp.toLittleChar')" type="error" banner />
            </div>
            <div class="d-flex flex-row align-items-center justify-content-center">
                <vue-country-code
                    class="col-3 country-code"
                    :enabledCountryCode="true"
                    @onSelect="onSelect($event)"
                    defaultCountry="tr"
                />
                <div class="col-8">
                    <a-input
                        v-model="whatsappNumber"
                        :placeholder="$t('message.phone')"
                        autocomplete="off"
                        trim
                        type="text"
                        v-validate="'required|numeric|min:6|max:15'"
                    />
                </div>
            </div>
        </a-modal>
        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="this.$t('whatsappChannel.whatsappChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteWhatsappChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWhatsappChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import WhatsappWizard from "../../WhatsappV1/update/WhatsappWizard.vue";
import ContactListV2 from "../../WhatsappV1/ContactListV2.vue";
import SettingsMultiWhatsapp from "../../WhatsappV1/SettingsMultiWhatsapp.vue";
import WhatsappBusinessIcon from "../../Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import IconButton from "../../Settings/components/IconButton.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import _ from "lodash";
import ChannelMenu from "./ChannelMenu.vue";
import Visibility from "./Visibility.vue";
import log2 from "../../../../utils/log2";
import WABusinessMenuTypes from "./WABusinessMenuTypes";
import TemplateMessageList from "./TemplateMessageList.vue";
import TemplateMessageForm from "./template/TemplateMessageForm.vue";
import BroadcastRequests from "./broadcast/BroadcastRequests.vue";
import CustomerGroups from "./broadcast/CustomerGroups.vue";
import AllContacts from "./AllContacts.vue";
import UpdateDetail from "./UpdateDetail.vue";
import ChatInitiatorTemplate from "./ChatInitiatorTemplate.vue";
import Numbers from "./Numbers.vue";
import VueCountryCode from "vue-country-code";
import SYSTEM_PUBSUB from "../../../../utils/systemPubSub";
import { filter, first, timeout } from "rxjs/operators";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import DailyUsages from "./DailyUsages.vue";
import Wallet from "../../Settings/pages/Wallet.vue";

const log = log2("WhatsappBusinessChannelDetail.vue");
export default Vue.extend({
    name: "WhatsappBusinessChannelDetail",
    components: {
        DailyUsages,
        VueCountryCode,
        Numbers,
        ChatInitiatorTemplate,
        UpdateDetail,
        CustomerGroups,
        BroadcastRequests,
        TemplateMessageForm,
        TemplateMessageList,
        Visibility,
        ChannelMenu,
        IconButton,
        WhatsappBusinessIcon,
        SettingsMultiWhatsapp,
        ContactListV2,
        WhatsappWizard,
        AllContacts,
        AppBreadCrumb,
        Wallet,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(WABusinessMenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            WABusinessMenuTypes,
            visible: this.$route.query.action == "start-chat",
            confirmLoading: false,
            whatsappNumber: "",
            showAlertMessage: false,
            dialCode: "+90",
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-business-api"),
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.chatbotStory = null;
            } else {
                if (this.stories[0]) {
                    this.form.chatbotStory = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        deleteWhatsappChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/whatsapp-business-api");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.whatsappNumber = "";
            this.showAlertMessage = false;
        },
        onSelect(value) {
            log("onSelect", value);
            this.dialCode = value.dialCode;
        },
        startChat(whatsappNumber) {
            log("startChat", { whatsappNumber });
            whatsappNumber = this.dialCode + whatsappNumber;
            const maybeJoinedChat = this.myActiveConversations.find((x) => x.whatsappNumber === whatsappNumber);

            if (!!maybeJoinedChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT, {
                    conversationId: maybeJoinedChat._id,
                });
            } else {
                const hide = this.$message.loading(this.$t("wp.chatStartingWait"), 0);

                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "join_chat_immediately"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        this.$message.success(this.$t("wp.chatStarted"));
                        this.visible = false;
                        this.whatsappNumber = "";
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                        this.visible = false;
                    })
                    .finally(() => {
                        hide();
                    });

                sendSocketMessage("user start-chat", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    whatsappNumber,
                    channelId: this.channel._id,
                    channelType: "whatsapp-business-api",
                });
            }
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(WABusinessMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/whatsapp-business-api/${this.channel._id}/detail/${selected.path}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#wa-business-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                    background: #58ca64;
                    padding: 10px;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
